export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-regular-e464241bd44d99ce5121a9a62fee338c.eot";